import gql from 'graphql-tag';

export const ALL_MUTUAL_FUNDS = gql`
    query allMutualFunds {
        allMutualFunds {
            label: shortName
            value: ticker
        }
    }
`;

export const ALL_EXCHANGE_TRADED_FUNDS = gql`
    query allExchangeTradedFunds {
        allExchangeTradedFunds {
            label: shortName
            value: ticker
        }
    }
`;

export const ALL_FUNDS = gql`
    query allFunds {
        allExchangeTradedFunds {
            label: shortName
            value: ticker
            publicOfferingDate: publicOfferingDate
        }

        allMutualFunds {
            label: shortName
            value: ticker
            openToNewInvestors
            openToSubsequentInvestments
        }
    }
`;
